export default __webpack_public_path__ + "static/media/this-place-is-called.d1c2c2c8.jpg";